export default {
  iconUp: '上移',
  iconDown: '下移',
  iconAdd: '添加',
  iconEdit: '编辑',
  iconDelete: '删除',
  iconConfig: '高级设置',
  iconCopy: '复制',
  iconSave: '保存',
  iconCancel: '取消',
  iconImage: '上传图片',
  btnSave: '保存',
  btnClose: '关闭',
  btnCancel: '取消',
  widthImage: '宽图',
  longImage: '长图',
  tipOptionNull: '不能为空！',
  tipImageNull: '请上传图片！',
  tipDescNull: '题目不能为空！',
  tipCeOptionNull: '区域Code和名称不能为空！',
  tipSubQuestionNull: '子问题不能为空！',
  tipChooseTypeNull: '选择类型不能为空！',
  tipAnQuItemIdNull: '选项不能为空！',
  tipSortQuItemIdNull: '排序内容不能为空！',
  tipAnValueNull: '选项值不能为空！',
  tipGeLeNull: '区间不能为空！',
  tipMinValueNull: '最小值不能为空！',
  tipMaxValueNull: '最大值不能为空！',
  tipLogicTypeNull: '逻辑类型不能为空！',
  tipToQuIdNull: '跳转题目不能为空！',
  tipToQuValueNull: '赋值内容不能为空！',
  tipToQuItemIdNull: '跳转题目不能为空！',
  tipAnAndNull: '条件不能为空！',
  tipAnQuIdNull: '题目不能为空！',
  tipAnSubQuIdNull: '子问题不能为空！',
  tipTitleNull: '标题不能为空！',
  tipAnswerNull: '答案不能为空！',
  tipSortNull: '排序尚未完成！',
  tipScoreNull: '请给本题打分！',
  tipRangeNull: '不能超过范围！',
  tipMax: '剩余可分配',
  tipNotMax: '尚未分配完全！',
  tipRateNull: '还有有子问题未回答！',
  tipPhoneError: '请输入正确的11位手机号码',
  tipEmailError: '请输入正确的邮箱',
  tipBirthdayError: '请输入正确的生日',
  tipIdCardError: '请输入正确的身份证号码',
  tipIatAnswerNull: '请向左向右以最快速度选择对应答案',
  tipNotEdit: '问卷状态不为[设计中]不能进行维护操作，请到发布页面更改问卷状态',
  msgAnswered: '您已完成问卷，确定回到活动页？',
  msgUnAnswered: '尚未完成问卷，确定回到活动页？',
  regionName: '区域名称',
  imageType: '图片类型',
  addDimension: '添加维度',
  allowChoiceNull: '允许被访者选择以上皆无',
  tipQuestionError: '请输入题干',
  logicOption: '选项逻辑',
  option: '选项',
  optionContent: '选项内容',
  countNumber: '总数',
  setUnit: '设置单位',
  customUnit: '自定义单位',
  usedUnit: '选择常用单位:',
  inputNumber: '输入数值',
  inputAddPosition: '添加输入位置',
  mediaPosition: '媒体文件位置：',
  mediaUp: '媒体文件上文下',
  mediaDown: '媒体文件下文上',
  insertPosition: '插入位置',
  playSpotInfo: '打点信息',
  playSpot: '打点',
  simulationPosition: '模拟位置，仅供预览',
  nowAtPosition: '当前所在位置',
  gpsError: '定位失败，请确保系统GPS已开启、浏览器已获取定位权限',
  brandImage: '品牌图片',
  addOption: '添加选项',
  brandName: '品牌名称',
  imageUp: '图上文下',
  imageDown: '文上图下',
  positionPut: '位置摆放:',
  maxSelectFive: '最多可添加5个选项!',
  leftRightChoiceAnswer: '请向左向右以最快速度选择对应答案',
  mediaType: '媒体类型：',
  minAnswer: '至少回答:',
  maxAnswer: '至多回答：',
  zeroNoAnswer: '若输入0，则此题为非必答题',
  openQuestion: '开放题：',
  mediaAudio: '语音',
  image: '图片',
  mediaVideo: '视频',
  recordingOnly: '仅录音',
  recordingToWord: '仅语音转文字',
  soundAndToWord: '录音并转文字',
  shotOnly: '仅可拍摄',
  uploadOnly: '仅可上传',
  shotAndUpload: '既可拍摄又可上传',
  inputNumerical: '请输入数字',
  choiceTime: '请选择时间',
  choiceYearMonth: '请选择年/月',
  choiceYearMonthDay: '请选择年/月/日',
  choiceDateTime: '请选择日期时间',
  maxValue: '值上限',
  minValue: '值下限',
  supportType: '支持类型',
  Integer: '整数',
  supportDecimal: '支持两位小数',
  startTime: '开始时间',
  choiceStartTime: '选择开始时间',
  endTime: '结束时间',
  choiceEndTime: '选择结束时间',
  startYearMonth: '开始年/月',
  choiceStartYearMonth: '选择开始年/月',
  endYearMonth: '结束年/月',
  choiceEndYearMonth: '选择结束年/月',
  startYearMonthDay: '开始年/月/日',
  choiceStartYearMonthDay: '选择开始年/月/日',
  endYearMonthDay: '结束年/月/日',
  choiceEndYearMonthDay: '选择结束年/月/日',
  choiceStartDateTime: '选择开始日期时间',
  choiceEndDateTime: '选择结束日期时间',
  answerLogic: '答案逻辑',
  minValueNotNull: '值下限不能为空',
  minValueLtMaxValue: '值下限不能大于值上限',
  mustInteger: '必须为整数',
  maxTwoDecimal: '最多为两位小数',
  maxValueNotNull: '值上限不能为空',
  maxValueLtMinValue: '值上限不能小于值下限',
  supportTypeNotNull: '支持类型不能为空',
  second: '秒',
  minute: '分钟',
  hour: '小时',
  element: '元',
  dollar: '美元',
  euro: '欧元',
  frequency: '次',
  day: '天',
  percentage: '百分比',
  timeRange: '时间范围',
  custom: '自定义',
  hourMinute: '时/分',
  date: '日期',
  yearMonth: '年/月',
  yearMonthDay: '年/月/日',
  dateTime: '日期/时间',
  pageNumber: '页码',
  npsTit: 'NPS题',
  likertScale: '利克特量表',
  star: '星形',
  bipolarScale: '双极量表',
  silder: '滑块',
  exactScale: '正好尺度',
  againOrder: '重新排序',
  pleaseInput: '请输入',
  middleValue: '之间的值',
  subQuestion: '子问题',
  questionStem: '题干',
  ifText: '若',
  useMultiple: '可多选，选项间为“或”的关系',
  choiceSelect: '选择选项',
  choiceSerial: '选择序号',
  rankingAs: '排序为',
  choiceValue: '选择分值',
  inputValue: '输入分值',
  and: '和',
  middle: '之间',
  be: '则',
  selectSubQuestion: '选择子问题',
  addLogicOption: '添加逻辑项',
  ok: '确定',
  questionType: '题型',
  currentQuestion: '当前组',
  choiceSubQuestion: '请选择子问题',
  showThat: '显示该',
  group: '组',
  question: '题',
  groupPrefixLogic: '组前逻辑',
  questionPrefixLogic: '题前逻辑',
  answerVer: '答案验证',
  addAnswerVer: '添加答案验证条件',
  thatQuestion: '该题的',
  thatAnswer: '的答案',
  thatQuestionAnswer: '该题的答案',
  notAdd: '未添加',
  viewOrModify: '查看/修改',
  screeningPart: '甄别部分',
  endPageSet: '结束页面设置',
  otherPageSet: '其他问卷逻辑',
  setCompletionPage: '设置完成页面',
  tipSample: '*提示：当样本状态为：Complete完成/Overqouta超配额时显示。',
  title: '标题',
  pleaseInputTitle: '请输入标题',
  describe: '描述',
  pleaseInputDescribe: '请输入描述',
  setNotCompletionPage: '设置未完成页面',
  tipScreen: '*提示：当样本状态为：Screenout甄别/Qoutafull配额满时显示。',
  projectNameNotNull: '项目名称不能为空',
  projectTypeNotNull: '项目类型不能为空',
  typeNotNull: '品类不能为空',
  brandNotNull: '品牌不能为空',
  projectCycleNotNull: '项目周期不能为空',
  multilingualNotNull: '多语言不能为空',
  flgNotNull: '标签不能为空',
  tipText: '提示',
  gotIt: '知道了',
  saveSuccess: '保存成功',
  mainTitle: '主标题',
  subTitle: '副标题',
  addReferer: '添加引用',
  quote: '引用',
  of: '的',
  answer: '答案',
  alreadySelect: '已选答案',
  notSelect: '未选答案',
  optionOrder: '选项显示顺序',
  orderShow: '顺序显示',
  randomShow: '随机显示',
  whileShow: '循环显示',
  randType: '排序方式',
  randByChildQu: '子问题',
  randByOption: '选项',
  randBoth: '全部',
  answerNumber: '答案个数',
  minSelect: '最少选',
  unlimited: '不限',
  maxSelect: '最多选',
  optionSet: '选项设置',
  customOptionMutex: '自定义选项互斥',
  setExclusions: '设置排他项',
  setMutex: '设置互斥项',
  pleaseCheckOtherOption: '请勾选需要排他的选项',
  checkTwoMutex: '请勾选需要互斥的2个选项',
  confirmDelete: '确认删除?',
  addQuestion: '添加题目',
  to: '至',
  beShowGroup: '则显示该组',
  currentGroup: '当前组与',
  existsLogic: '存在逻辑关联，不能删除！',
  project: '项目',
  questionnaire: '问卷',
  logic: '逻辑',
  preview: '外观',
  release: '发布',
  downLoad: '下载',
  maintainProject: '请先维护项目信息!',
  questionnaireDatabase: '问卷库',
  callQuestion: '调用问卷',
  coverQuestion: '即将覆盖当前问卷内容，确认继续？',
  currentQuestionAnd: '当前问题与',
  existsRelation: '存在关联，不能删除！',
  clickOrDragFile: '点击或者拖拽文件到此处进行上传',
  setAlias: '请设置附件别名',
  alias: '别名',
  fileFormatNotCorrect: '文件格式不正确',
  file: '文件',
  notImageFormat: '格式不正确, 请选择 jpg/png.',
  maxLimitExceeded: '超出最大限制',
  maxSetExceeded: '超出设定最大限制',
  maxUpload: '一次最多选择五个文件进行上传.',
  areaCode: '区域Code',
  noneOfTheAbove: '以上皆无',
  noneText: '无',
  maxAddDimension: '最多可添加5个维度！',
  answerNotNull: '答案不能为空，请在上图中圈选图案',
  unitNotNull: '单位不能为空',
  NULL_TIP: '不能为空',
  logic_random_title_order: '问题组出示顺序',
  logic_random_title_order_guding: '固定顺序',
  logic_random_title_order_suiji: '随机出示',
  logic_random_title_order_title: '请选择参与随机的问题组',

  submit: '提交',
  laststep: '上一题',
  nextstep: '下一题',
  submittedsuccessfully: '提交成功',

  cover: {
    title: '客户之声',
    desc: '您的反馈对我们至关重要',
    subTitle: "我们非常愿意聆听您的反馈",
    subDesc: "因为您的意见对我们非常重要，所以我们邀请您花费几分钟的时间参与我们的简单的问卷调研。",
    btn: '开始'
  },
  previewFinished: '当前回答仅供模拟',
  point: '分',
}



// WEBPACK FOOTER //
// ./src/assets/lang/zh.js